import { render } from "./ActionSendNotification.vue?vue&type=template&id=6d4b451c&scoped=true"
import script from "./ActionSendNotification.vue?vue&type=script&lang=js"
export * from "./ActionSendNotification.vue?vue&type=script&lang=js"

import "./ActionSendNotification.vue?vue&type=style&index=0&id=6d4b451c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4b451c"]])

export default __exports__